import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsHeading as Heading } from './src/Heading.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(Heading);
export const FsHeading = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-heading.js.map